var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.947 16.305C28.9369 15.5476 28.7951 14.7977 28.528 14.089C28.2963 13.4911 27.9425 12.9482 27.4892 12.4948C27.0358 12.0414 26.4928 11.6876 25.895 11.456C25.1953 11.1933 24.4562 11.0513 23.709 11.036C22.747 10.993 22.442 10.981 20 10.981C17.558 10.981 17.245 10.981 16.29 11.036C15.5432 11.0514 14.8043 11.1934 14.105 11.456C13.5071 11.6874 12.964 12.0412 12.5106 12.4946C12.0572 12.948 11.7035 13.491 11.472 14.089C11.2088 14.7881 11.0671 15.5271 11.053 16.274C11.01 17.237 10.997 17.542 10.997 19.984C10.997 22.426 10.997 22.738 11.053 23.694C11.068 24.442 11.209 25.18 11.472 25.881C11.7039 26.4787 12.0579 27.0215 12.5114 27.4747C12.965 27.9279 13.5081 28.2815 14.106 28.513C14.8034 28.7862 15.5424 28.9383 16.291 28.963C17.254 29.006 17.559 29.019 20.001 29.019C22.443 29.019 22.756 29.019 23.711 28.963C24.4581 28.9482 25.1974 28.8066 25.897 28.544C26.4947 28.312 27.0375 27.9581 27.4908 27.5048C27.9442 27.0515 28.2981 26.5086 28.53 25.911C28.793 25.211 28.934 24.473 28.949 23.724C28.992 22.762 29.005 22.457 29.005 20.014C29.003 17.572 29.003 17.262 28.947 16.305ZM19.994 24.602C17.44 24.602 15.371 22.533 15.371 19.979C15.371 17.425 17.44 15.356 19.994 15.356C21.2201 15.356 22.396 15.843 23.2629 16.71C24.1299 17.577 24.617 18.7529 24.617 19.979C24.617 21.2051 24.1299 22.3809 23.2629 23.2479C22.396 24.1149 21.2201 24.602 19.994 24.602ZM24.801 16.263C24.6594 16.2631 24.5192 16.2353 24.3883 16.1812C24.2575 16.127 24.1386 16.0476 24.0384 15.9475C23.9383 15.8474 23.8589 15.7285 23.8048 15.5976C23.7507 15.4668 23.7229 15.3266 23.723 15.185C23.723 15.0435 23.7509 14.9033 23.805 14.7726C23.8592 14.6419 23.9385 14.5231 24.0386 14.423C24.1386 14.323 24.2574 14.2436 24.3882 14.1895C24.5189 14.1353 24.659 14.1075 24.8005 14.1075C24.942 14.1075 25.0821 14.1353 25.2128 14.1895C25.3436 14.2436 25.4623 14.323 25.5624 14.423C25.6625 14.5231 25.7418 14.6419 25.796 14.7726C25.8501 14.9033 25.878 15.0435 25.878 15.185C25.878 15.781 25.396 16.263 24.801 16.263Z",
    fill: "url(#paint0_linear_5611_41974)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.994 22.9821C21.6525 22.9821 22.997 21.6376 22.997 19.9791C22.997 18.3206 21.6525 16.9761 19.994 16.9761C18.3355 16.9761 16.991 18.3206 16.991 19.9791C16.991 21.6376 18.3355 22.9821 19.994 22.9821Z",
    fill: "url(#paint1_linear_5611_41974)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5611_41974",
    x1: 10.997,
    y1: 20,
    x2: 29.005,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5611_41974",
    x1: 16.991,
    y1: 19.9791,
    x2: 22.997,
    y2: 19.9791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgIcon);
export default __webpack_public_path__ + "static/media/ig-icon.c2a0149a7c6e23007e141a5ccc05db3e.svg";
export { ForwardRef as ReactComponent };